module.exports = __webpack_public_path__ + "static/media/calendar-disabled.2a59e880.svg";